// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__JW8JH","main":"Hero_main__p2B9N","aside":"Hero_aside__9HssA","dateInput":"Hero_dateInput__upd2B"};